<template>
  <div id="csContainer">
    <div class="toolbar">
      <el-button size="small" type="primary" @click="drag()">拖拽功能</el-button>
      <el-button size="small" type="primary" plain @click="cancel()">取消</el-button>
    </div>

  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
                isShow: false,
                viewer: null,
                handler:null
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
              let viewer = util.getViewer("csContainer");
              this.viewer = viewer;
              var position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0);

              var heading = Cesium.Math.toRadians(135);
              var pitch = 0;
              var roll = 0;
              var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
              var orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
              var entity = viewer.entities.add({
                name : 'url',
                position : position,
                orientation : orientation,
                model : {
                  uri : "/demo/static/data/models/car.glb",
                  minimumPixelSize : 1,
                  maximumScale : 200,
                  scale:1
                }
              });
              viewer.zoomTo(viewer.entities);
            },
            drag(){
              let viewer = this.viewer;
              let leftDownFlag = false;
              let pointDraged = null;
              viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);


              this.handler = new Cesium.ScreenSpaceEventHandler(viewer.canvas);

              this.handler.setInputAction(function (movement) {
                pointDraged = viewer.scene.pick(movement.position);//选取当前的entity
                leftDownFlag = true;
                if (pointDraged) {
                  viewer.scene.screenSpaceCameraController.enableRotate = false;//锁定相机
                }
              }, Cesium.ScreenSpaceEventType.LEFT_DOWN);


              this.handler.setInputAction(function () {
                leftDownFlag = false;
                pointDraged = null;
                viewer.scene.screenSpaceCameraController.enableRotate = true;
                viewer.scene.screenSpaceCameraController.enableInputs = true;
              }, Cesium.ScreenSpaceEventType.LEFT_UP);

              this.handler.setInputAction(function (movement) {
                if (leftDownFlag === true && pointDraged != null) {
                  let ray = viewer.camera.getPickRay(movement.endPosition);
                  let cartesian = viewer.scene.globe.pick(ray, viewer.scene);
                  console.log(cartesian);
                  pointDraged.id.position = new Cesium.CallbackProperty(function () {
                    return cartesian;
                  }, false);//防止闪烁，在移动的过程
                }
              }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

              // handler.setInputAction(function (movement) {
              //   handler.destroy();
              //
              // },Cesium.ScreenSpaceEventType.RIGHT_CLICK);
            },
          cancel(){
              if(this.handler != null ){
                this.handler.destroy();
              }

          }

        }
    }
</script>
<style scoped>
  .headMap {
    position: absolute;
    margin-left: 25px;
    margin-top:7px;
    z-index: 999;
  }
  #heatmap{
    width: 500px;
    height: 500px;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
